<template>
  <v-btn-form :title="title" @close="cancel()">
      <v-list two-line dense>
        <template v-for="item in this.filteredItems">
          <v-list-tile v-bind:key="getItemKey(item)" @click.stop="cxt.select(getItemKey(item))">
             <v-list-tile-content>
              <b>{{item.text}}</b>
            </v-list-tile-content>
            <v-list-tile-action>
            <v-icon v-show="cxt.check(getItemKey(item))">check_box</v-icon>
            <v-icon v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    <template #actions>
      <v-btn @click="ok">ОК</v-btn>
    </template>
  </v-btn-form>  
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import vCardScroll from '../common/CardScroll'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'docprop-selector',
    components: {vCardScroll, vBtnForm},
    data: () => ({
      cxt: null
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: function () {
          return []
        }
      },
      items: {
        type: Array,
        default: function () {
          return []
        }
      },
      title: {
        type: String,
        default: 'Выберите документ'
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.mode = classes.modes.SELECT
      this.cxt = cxt
      if (this.selected != null) {
        this.selected.forEach(id => this.cxt.select(id))
      }
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll'
      }),
      orderedItems () {
        console.log('orderedItems', this.items)
        return this.items.sort((a, b) => formats.compareString(a.docName, b.docName))
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(item.docName)
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      }
    },
    methods: {
      getItemKey (item) {
        return item.value
      },
      ok () {
        this.$emit('input', this.cxt.selected())
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      }
    }
  }
</script>




// WEBPACK FOOTER //
// DocPropSelector.vue?da4d9116